import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';

export default function NotFound() {
  return (
    <SiteLayout>
      <div className="w-full px-4 md:px-6 py-24 flex flex-col items-center text-center">
        <span className="font-display text-7xl md:text-9xl font-bold text-background-300 select-none">
          404
        </span>
        <h1 className="mt-6 font-display text-2xl md:text-3xl font-bold text-foreground-950">
          页面走丢了
        </h1>
        <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-md">
          你访问的页面不存在或已被移除，回到首页继续发现精彩视频吧。
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer"
          >
            <i className="ri-home-5-line"></i>
            返回首页
          </Link>
          <Link
            to="/search"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-background-100 border border-background-300 hover:border-primary-400 text-foreground-800 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer"
          >
            <i className="ri-search-line"></i>
            去搜索视频
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}